// Paneles compactos: eventos centinela activos y casos vencidos.
import React from 'react';
import { Link } from 'react-router-dom';
import { Bell, Clock, ArrowRight } from 'lucide-react';
import { nivelInfo, carrilInfo, ESTADOS, anonLabel } from '../../../lib/dashboardVocab';

function CasoRow({ c, extra }) {
  const nivel = nivelInfo(c.nivel_alerta);
  const carril = carrilInfo(c.carril);
  return (
    <li className="flex items-center gap-3 py-2.5 border-b border-[#F1F3F9] last:border-0" data-testid={`row-${c.id}`}>
      <span
        className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold shrink-0"
        style={{ background: nivel.bg, color: nivel.fg }}
      >
        <span className="w-1.5 h-1.5 rounded-full" style={{ background: nivel.dot }} />
        {nivel.label}
      </span>
      <span
        className="inline-block px-2 py-0.5 rounded-full text-[10px] font-bold shrink-0"
        style={{ background: carril.bg, color: carril.fg }}
      >
        {carril.label}
      </span>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-bold text-[#0B1B5E] truncate">
          {anonLabel(c)}
        </div>
        <div className="text-[11px] text-[#475472] truncate">
          {c.dominio_code} · {ESTADOS[c.estado] || c.estado}
          {extra ? ` · ${extra(c)}` : ''}
        </div>
      </div>
      <Link
        to={`/admin/dashboard/casos/${c.id}`}
        className="text-[#5346E6] hover:text-[#0B1B5E]"
        aria-label="Ver caso"
        data-testid={`link-caso-${c.id}`}
      >
        <ArrowRight className="w-4 h-4" />
      </Link>
    </li>
  );
}

export function SentinelEventsPanel({ casos = [], loading }) {
  return (
    <section
      aria-label="Eventos centinela activos"
      className="bg-white rounded-2xl border border-[#E5EAF5] p-5"
      data-testid="sentinel-events-panel"
    >
      <header className="mb-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="p-1.5 rounded-lg bg-[#FADBD8]">
            <Bell className="w-4 h-4 text-[#8A1616]" />
          </div>
          <h2 className="font-extrabold text-[#0B1B5E]">Eventos centinela activos</h2>
        </div>
        <span className="text-xl font-extrabold text-[#8A1616]" data-testid="sentinel-count">
          {loading ? '…' : casos.length}
        </span>
      </header>
      {loading ? (
        <div className="text-sm text-[#475472]">Cargando…</div>
      ) : casos.length === 0 ? (
        <div className="py-4 text-sm text-[#475472] text-center" data-testid="sentinel-empty">
          Sin eventos centinela activos.
        </div>
      ) : (
        <ul>{casos.slice(0, 5).map((c) => <CasoRow key={c.id} c={c} />)}</ul>
      )}
    </section>
  );
}

export function OverdueCasesPanel({ casos = [], loading }) {
  return (
    <section
      aria-label="Casos con seguimiento vencido"
      className="bg-white rounded-2xl border border-[#E5EAF5] p-5"
      data-testid="overdue-panel"
    >
      <header className="mb-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="p-1.5 rounded-lg bg-[#FFE4CC]">
            <Clock className="w-4 h-4 text-[#8A4200]" />
          </div>
          <h2 className="font-extrabold text-[#0B1B5E]">Seguimientos vencidos</h2>
        </div>
        <span className="text-xl font-extrabold text-[#8A4200]" data-testid="overdue-count">
          {loading ? '…' : casos.length}
        </span>
      </header>
      {loading ? (
        <div className="text-sm text-[#475472]">Cargando…</div>
      ) : casos.length === 0 ? (
        <div className="py-4 text-sm text-[#475472] text-center" data-testid="overdue-empty">
          Sin casos vencidos.
        </div>
      ) : (
        <ul>
          {casos.slice(0, 5).map((c) => (
            <CasoRow key={c.id} c={c} extra={(x) => `Vencido hace ${x.dias_vencido || 0} d.`} />
          ))}
        </ul>
      )}
    </section>
  );
}
